import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Tooltip } from '@material-ui/core';

export const Tab = ({ label, typeDefault, setTypeTable, typeCurrent, disabled, tooltip, ...props }) => {
  const tabContent =
    <Typography
      {...props}
      onClick={() => !disabled && setTypeTable(typeDefault)}
      sx={{
        borderBottom: typeCurrent === typeDefault ? '2px solid' : 'none',
        borderBottomColor: typeCurrent === typeDefault ? 'primary.main' : 'initial',
        color: typeCurrent !== typeDefault && 'text.secondary',
        margin: '20px',
        cursor: 'pointer',
        paddingBottom: '8px'
      }}
    >
      {label}
    </Typography>;

  return (
    tooltip && disabled ?
    <Tooltip title={tooltip} arrow sx={{pointerEvents: 'auto'}} data-testid="Tooltip">
      {tabContent}
    </Tooltip> :
    tabContent
  );
}

Tab.propTypes = {
  label: PropTypes.string,
  typeDefault: PropTypes.string,
  typeCurrent: PropTypes.string,
  setTypeTable: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
};
